import AddNoticeWrapper from './AddNoticeWrapper';

export default AddNoticeWrapper;
